<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="text-align: center;margin-top:180pt;font-weight:bold;">‘Hell is empty, and all the devils live here.’</p>
<p style="text-align: center;">The Tempest,t Act 1, Scene 2</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?9185281a